const getOrCreateLegendList = (container) => {
    let listContainer = container.querySelector('ul');
    if (!listContainer) {
        listContainer = document.createElement('ul');
        listContainer.style.display = 'flex';
        listContainer.style.flexDirection = 'column';
        listContainer.style.margin = 0;
        listContainer.style.padding = 0;
        container.appendChild(listContainer);
    }

    return listContainer;
};

const htmlLegend = {
    id: 'htmlLegend',
    afterUpdate(chart, args, options) {
        const ul = getOrCreateLegendList(options.container.current);
        while (ul.firstChild) {
            ul.firstChild.remove();
        }

        const items = chart.options.plugins.legend.labels.generateLabels(chart);
        items.sort((a, b) => a.text.localeCompare(b.text));
        items.forEach(item => {
            const li = document.createElement('li');
            li.style.alignItems = 'left';
            li.style.cursor = 'pointer';
            li.style.display = 'flex';
            li.style.flexDirection = 'row';
            li.style.marginTop = '5px';
            li.style.marginLeft = '5px';
            li.style.marginBottom = '0';
            li.style.whiteSpace = 'nowrap';
            li.style.height = '20px';

            li.onclick = (e) => {
                let index = item.datasetIndex;
                var alreadyHidden = (chart.getDatasetMeta(index).hidden === null) ? false : chart.getDatasetMeta(index).hidden;
                chart.data.datasets.forEach((e, i) => {
                    var meta = chart.getDatasetMeta(i);
                    if (i !== index) {
                        if (!alreadyHidden) {
                            meta.hidden = meta.hidden === null ? !meta.hidden : null;
                        } else if (meta.hidden === null) {
                            meta.hidden = true;
                        }
                    } else if (i === index) {
                        meta.hidden = null;
                    }
                });
                chart.update();
            };

            const boxSpan = document.createElement('span');
            boxSpan.style.background = item.fillStyle;
            boxSpan.style.border = "0.7px solid black"
            boxSpan.style.display = 'inline-block';
            boxSpan.style.flexShrink = '0';
            boxSpan.style.height = '20px';
            boxSpan.style.marginRight = '5px';
            boxSpan.style.width = '20px';

            const textContainer = document.createElement('p');
            textContainer.style.color = item.fontColor;
            textContainer.style.fontFamily = "ProximaNova";
            textContainer.style.fontSize = "0.875rem";
            textContainer.style.margin = '0';
            textContainer.style.padding = '0';
            textContainer.style.textDecoration = item.hidden ? 'line-through' : '';

            const text = document.createTextNode(item.text);
            textContainer.appendChild(text);

            li.appendChild(boxSpan);
            li.appendChild(textContainer);
            ul.appendChild(li);
        });
    }
};

export default htmlLegend;